module.exports = __webpack_public_path__ + "static/media/tree-frog-001.d5e143b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/tree-frog-001.png
// module id = 254
// module chunks = 1